import React, { useEffect } from 'react'
import ImsaTable from '../../Components/ImsaTable/page'
import Banner2 from '../../Components/Banner/Banner2'

const Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Banner2 title="WELCOME TO IMSA " backgroundImage="/assets/images/banner/video-banner-1.jpg"/>
    {/* <DriverSec3/> */}
    <ImsaTable/>
    </>
  )
}

export default Page